const LocalStorageConst = Object.freeze({
    LOCALE: "last-locale"
})

export default LocalStorageConst
